var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg2VideoActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 1280",
    style: {
      enableBackground: "new 0 0 1280 1280"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#006EFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1280,
    height: 1280
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1184,448H288c-17.7,0-32,14.3-32,32v640c0,17.7,14.3,32,32,32h896c17.7,0,32-14.3,32-32V480 C1216,462.3,1201.7,448,1184,448z M624,945.6V654.4c0-4.4,3.6-8,8-8c1.5,0,3,0.4,4.2,1.2l232.9,145.6c3.7,2.3,4.9,7.3,2.5,11 c-0.6,1-1.5,1.9-2.5,2.5L636.2,952.3c-3.7,2.3-8.7,1.2-11-2.5C624.4,948.5,624,947.1,624,945.6z M320,512h128v64H320V512z  M320,640h128v128H320V640z M320,832h128v128H320V832z M320,1024h128v64H320V1024z M1152,1088h-128v-64h128V1088z M1152,960h-128 V832h128V960z M1152,768h-128V640h128V768z M1024,576v-64h128v64H1024z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360.8,277.4L254.2,384h90.5l38.7-38.7l38.7,38.7h90.5L406,277.4C393.5,265,373.3,265,360.8,277.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M992,128H96c-17.7,0-32,14.3-32,32v640c0,17.7,14.3,32,32,32h96v-64h-64V600.7l64-64v-90.5l-64,64V192h832 v192h64V160C1024,142.3,1009.7,128,992,128z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2VideoActive);
export default __webpack_public_path__ + "static/media/img2video_active.54272588a598dd2da799ef668d108b96.svg";
export { ForwardRef as ReactComponent };